<template>
  <ValidationObserver ref="form" v-slot="{ invalid }">
    <form>
      <div v-if="userType == 'employee'" class="wrapper-emp">
        <div class="card" :class="{ 'active': selected == 1 }">
          <div v-b-toggle.collapse-1 @click="selected = selected == 1 ? 0: 1" class="top">
            <img v-if="selected == 1" src="/assets/images/user_active.png" alt="">
            <img v-else src="/assets/images/user.png" alt="">
            <span>1 - Register here to receive the free Voucher </span>
          </div>
          <b-collapse visible id="collapse-1" class="bottom">
            <ValidationProvider rules="required|email" v-slot="{ errors }" name="email">
              <input
                type="email"
                name="empEmail"
                id="empEmail"
                v-model="empEmail"
                placeholder="Email*"
              >
              <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
          </b-collapse>
        </div>
        <button-component
          text="Register"
          addClass="btn-next col-4"
          :disabled="invalid || submitted"
          @click.native="sendForm"
        />
        <div class="card" :class="{ 'active': selected == 2 }">
          <div v-b-toggle.collapse-2 @click="selected = selected == 2 ? 0: 2" class="top">
            <img v-if="selected == 2" src="/assets/images/mobile_active.png" alt="">
            <img v-else src="/assets/images/mobile.png" alt="">
            <span>2 - Download the app “Wings for Life World Run”</span>
          </div>
          <b-collapse id="collapse-2" class="bottom">
            <div style="margin-bottom: 10px;text-align: left;">Available on:</div>
            <div class="row">
              <div class="col-4">
              <a href="https://play.google.com/store/apps/details?id=com.redbull.wingsforlifeworldrun&hl=en&gl=US" target="_blank" rel="noopener noreferrer">
                <img style="max-width: 100%;" src="/assets/images/googleplay.png" alt="Google play">
              </a>
              </div>
              <div class="col-4">
              <a href="https://apps.apple.com/us/app/wings-for-life-world-run/id956816207" target="_blank" rel="noopener noreferrer">
                <img style="max-width: 100%;" src="/assets/images/applestore.png" alt="Apple store">
              </a>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card" :class="{ 'active': selected == 3 }">
          <div class="top">
            <img v-if="selected == 3" src="/assets/images/user_active.png" alt="">
            <img v-else src="/assets/images/user.png" alt="">
            <span>3 - Sign-up for App Running (with the Voucher Code you just received)</span>
          </div>
        </div>
        <div class="card" :class="{ 'active': selected == 4 }">
          <b-tooltip ref="tooltip" target="copied-tooltip" noninteractive>
            {{  $t('Copied to clipboard') }}
          </b-tooltip>
          <div v-b-toggle.collapse-4 @click="selected = selected == 4 ? 0: 4" class="top">
            <img v-if="selected == 4" src="/assets/images/share_active.png" alt="">
            <img v-else src="/assets/images/share.png" alt="">
            <span>4 - Join the GO TPV Cares! team in the App</span>
          </div>
          <b-collapse id="collapse-4" class="bottom row justify-content-between">
            <input type="text" disabled="disabled" id="copied-tooltip" ref="target1" placeholder="bit.ly/JoinTPVisionTeam26" aria-label="Value" value="bit.ly/JoinTPVisionTeam26">
            <button style="max-width: 100px;" class="btn col-2" @click.prevent="copy('target1')">Copy</button>
            <span style="font-size: 14px; width: 80%;">* The personal link to track the referral program will be available from March 8th in your app profile</span>
          </b-collapse>
        </div>
        <div class="card">
          <div class="top">
            <img src="/assets/images/chat.png" alt="">
            <span>5 - HAVE FUN!!!</span>
          </div>
        </div>
      </div>
      <div v-else class="wrapper-par">
        <div class="card" :class="{ 'active': selected == 1 }">
          <div v-b-toggle.collapse-1 @click="selected = selected == 1 ? 0: 1" class="top">
            <img v-if="selected == 1" src="/assets/images/user_par.png" alt="">
            <img v-else src="/assets/images/user.png" alt="">
            <span>1 - Register here to receive the free Voucher </span>
          </div>
          <b-collapse visible id="collapse-1" class="bottom">
            <ValidationProvider rules="required|email" v-slot="{ errors }" name="email">
              <input
                type="email"
                name="parEmail"
                id="parEmail"
                v-model="parEmail"
                placeholder="Email*"
              >
              <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }" name="address">
              <input
                type="text"
                name="address"
                id="address"
                v-model="parAddress"
                placeholder="Home Address*"
              >
            <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }" name="postal">
              <input
                type="text"
                name="postal"
                id="postal"
                v-model="parPostal"
                placeholder="Postal Code*"
              >
            <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }" name="city">
              <input
                type="text"
                name="city"
                id="city"
                v-model="parCity"
                placeholder="City*"
              >
            <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }" name="country">
              <input
                type="text"
                name="country"
                id="country"
                v-model="parCountry"
                placeholder="Country*"
              >
            <div v-if="errors.length" class="validation-error">{{errors[0]}}</div>
            </ValidationProvider>
          </b-collapse>
        </div>
        <button-component
          text="Register"
          addClass="btn-back col-4"
          :disabled="invalid || submitted"
          @click.native="sendForm"
        />
        <div class="card" :class="{ 'active': selected == 2 }">
          <div v-b-toggle.collapse-2 @click="selected = selected == 2 ? 0: 2" class="top">
            <img v-if="selected == 2" src="/assets/images/mobile_par.png" alt="">
            <img v-else src="/assets/images/mobile.png" alt="">
            <span>2 - Download the App “Wings for Life World Run”</span>
          </div>
          <b-collapse id="collapse-2" class="bottom">
            <div style="margin-bottom: 10px;text-align: left;">Available on:</div>
            <div class="row">
              <div class="col-4">
              <a href="https://play.google.com/store/apps/details?id=com.redbull.wingsforlifeworldrun&hl=en&gl=US" target="_blank" rel="noopener noreferrer">
                <img style="max-width: 100%;" src="/assets/images/googleplay.png" alt="Google play">
              </a>
              </div>
              <div class="col-4">
              <a href="https://apps.apple.com/us/app/wings-for-life-world-run/id956816207" target="_blank" rel="noopener noreferrer">
                <img style="max-width: 100%;" src="/assets/images/applestore.png" alt="Apple store">
              </a>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="card">
          <div class="top">
            <img src="/assets/images/chat.png" alt="">
            <span>3 - Sign-up for App Running (with the voucher code you just received)</span>
          </div>
        </div>
        <div class="card" :class="{ 'active': selected == 4 }">
          <b-tooltip ref="tooltip" target="copied-tooltip" noninteractive>
            {{  $t('Copied to clipboard') }}
          </b-tooltip>
          <div v-b-toggle.collapse-4 @click="selected = selected == 4 ? 0: 4" class="top">
            <img v-if="selected == 4" src="/assets/images/share_par.png" alt="">
            <img v-else src="/assets/images/share.png" alt="">
            <span>4 - Join the GO TPV Cares! team in the App</span>
          </div>
          <b-collapse id="collapse-4" class="bottom row justify-content-between">
            <input type="text" disabled="disabled" id="copied-tooltip" ref="target2" placeholder="bit.ly/JoinTPVisionTeam26" aria-label="Value" value="bit.ly/JoinTPVisionTeam26">
            <button style="max-width: 100px;" class="btn col-2" @click.prevent="copy('target2')">Copy</button>
            <span style="font-size: 14px; width: 80%;">* The personal link to track the referral program will be available from March 8th in your app profile</span>
          </b-collapse>
        </div>
        <div class="card">
          <div class="top">
            <img src="/assets/images/chat.png" alt="">
            <span>5 - HAVE FUN!!!</span>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import ButtonComponent from './button-component.vue';
import { mapGetters } from 'vuex';
export default {
  name: "new-form",
  components: {
    ButtonComponent
  },
  data () {
    return {
      empEmail: '',
      parEmail: '',
      parAddress: '',
      parStreet: '',
      parPostal: '',
      parCity: '',
      parCountry: '',
      selected: 1,
      submitted: false
    }
  },
  props: {
    apiUrl: {
      type: String,
      default: ''
    },
    successAction: {
      type: Object,
      default: () => {}
    },
    userType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(["customerToken", "campaignId", "receiptToken"])
  },
  methods: {
    reset () {
      this.empEmail = '',
      this.parEmail = '',
      this.parAddress = '',
      this.parStreet = '',
      this.parPostal = '',
      this.parCity = '',
      this.parCountry = ''
    },
    copy (target) {
      var copyText = this.$refs[target];
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      navigator.clipboard.writeText(copyText.value);
      this.$refs.tooltip.$emit('open')
      setTimeout(() => {
        this.$refs.tooltip.$emit('close')
      }, 2000)
    },
    sendForm () {
      const formData = {}
      formData.customerToken = this.customerToken
      formData.campaignId = this.campaignId
      formData.receiptToken = this.receiptToken
      if (this.userType === 'employee') {
        formData.email = this.empEmail
        formData.address = '',
        formData.postal = '',
        formData.city = '',
        formData.country = ''
      } else {
        formData.email = this.parEmail
        formData.address = this.parAddress,
        formData.postal = this.parPostal,
        formData.city = this.parCity,
        formData.country = this.parCountry
      }
      this.$store.dispatch('sendFormData', { formData: formData, apiUrl: this.apiUrl })
        .then(res => {
          this.submitted = true;
          if (res) {
            const fn = this.successAction.fn;
            const params = this.successAction.params;
            this[fn](params, this);
          } else {
            this.showModal('Something went wrong', 'error')
          }
        })
        .catch(err => {
          console.log("Error: ", err)
          this.reset ()
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-emp {
  margin: 20px auto;
  text-align: center;
  .card {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: none;
    width: 100%;
    margin: 20px auto;
    &.active {
      color: var(--emp-color);
    }
    .top {
      display: flex;
      justify-content: flex-start;
      img {
        max-width: 30px;
        max-height: 30px;
        margin-right: 20px;
      }
      span {
        text-align: left;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
      }
    }
    .bottom {
      width: 100%;
      margin: 20px 30px;
      text-align: left;
      input {
        background: #FFFFFF;
        border: 1px solid rgba(166, 99, 13, 0.3);
        box-sizing: border-box;
        border-radius: 10px;
        height: 46px;
        width: 80%;
        padding: 10px;
      }
      .btn {
        border: none;
        color: #FFF;
        background: var(--emp-color);
        border-radius: 30px;
      }
    }
  }
}
.wrapper-par {
  margin: 20px auto;
  text-align: center;
  .card {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: none;
    width: 100%;
    margin: 20px auto;
    &.active {
      color: var(--par-color);
    }
    .top {
      display: flex;
      justify-content: flex-start;
      img {
        max-width: 30px;
        max-height: 30px;
        margin-right: 20px;
      }
      span {
        text-align: left;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
      }
    }
    .bottom {
      width: 100%;
      margin: 20px 30px;
      text-align: left;
      input {
        background: #FFFFFF;
        border: 1px solid rgba(166, 99, 13, 0.3);
        box-sizing: border-box;
        border-radius: 10px;
        height: 46px;
        width: 80%;
        padding: 10px;
        margin: 5px 0;
      }
      .btn {
        border: none;
        color: #FFF;
        background: var(--par-color);
        border-radius: 30px;
      }
    }
  }
}

#copied-tooltip {
  &::placeholder {
    font-size: 14px;
  }
}
</style>
